<template>
  <div v-tooltip="!!countryCode && ip">
    <div class="text-text-ternary text-xs mb-2">
      <template v-if="!!countryCode">{{ city }}</template>
      <template v-else>IP</template>
    </div>
    <div class="text-secondary text-sm">
      <template v-if="!!countryCode">
        <gb-flag
            v-if="!!countryCode"
            class="mr-2"
            :code="countryCode"
            size="micro"
        />
        {{ `${country},` }}
      </template>
      <template v-else>{{ ip }}</template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Geo",
  props: ['ip', 'countryCode', 'city', 'country']
}
</script>